import _classCallCheck from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createClass.js";
import ri from "./trigger-condition.js";
var ur = /*#__PURE__*/function () {
  function ur(t) {
    _classCallCheck(this, ur);
    this["if"] = t, this["if"] = t;
  }
  _createClass(ur, [{
    key: "xc",
    value: function xc(t) {
      return null == this["if"] || ri.sf(t[0], this["if"]);
    }
  }, {
    key: "dt",
    value: function dt() {
      return this["if"];
    }
  }], [{
    key: "fromJson",
    value: function fromJson(t) {
      return new ur(t ? t.campaign_id : null);
    }
  }]);
  return ur;
}();
export { ur as default };